import './header.scss';

const selectors = {
  header: '[data-header]',
  headerMenu: '[data-header-menu]',
  headerMenuTrigger: '[data-header-menu-trigger]',
  headerMenuItem: '[data-header-menu-item]',
  headerSubmenuTrigger: '[data-header-submenu-trigger]',

  active: 'active',
};

const handleMenuItemClick = (selectedItem, menuItems) => {
  menuItems.forEach((menuItem) => {
    const isActive = menuItem.classList.contains(selectors.active);
    const isSelectedItem = menuItem.isSameNode(selectedItem);

    if (isSelectedItem && !isActive) {
      menuItem.classList.add(selectors.active);
    } else {
      menuItem.classList.remove(selectors.active);
    }
  });
};

const handleClickOutside = (event, menu, menuItems) => {
  const isClickOutside = !menu.contains(event.target);

  if (isClickOutside) {
    menuItems.forEach((menuItem) =>
      menuItem.classList.remove(selectors.active)
    );
  }
};

const initHeader = (header) => {
  const menu = header.querySelector(selectors.headerMenu);
  const menuItems = menu.querySelectorAll(selectors.headerMenuItem);
  const menuTriggers = header.querySelectorAll(selectors.headerMenuTrigger);

  menuItems.forEach((menuItem) => {
    const triggers = menuItem.querySelectorAll(selectors.headerSubmenuTrigger);

    triggers.forEach((trigger) =>
      trigger.addEventListener('click', () =>
        handleMenuItemClick(menuItem, menuItems)
      )
    );
  });

  menuTriggers.forEach((menuTrigger) =>
    menuTrigger.addEventListener('click', () =>
      header.classList.toggle(selectors.active)
    )
  );

  document.addEventListener('click', (e) =>
    handleClickOutside(e, menu, menuItems)
  );

  document.body.style.setProperty(
    '--scroll-margin-top',
    header.clientHeight + 'px'
  );
};

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const header = document.querySelector(selectors.header);

    header && initHeader(header);
  },
  {
    once: true,
  }
);
